export default "__VITE_ASSET__optGec8c__"